import axios, { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';
import store from 'cache/store';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_RH_MINIGAME,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const { apiToken } = store.getState().auth;

        if (apiToken) {
            config.headers['Authorization'] = `Bearer ${apiToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const rongHoApi = {
    getRank(params: { type: number; access_token: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.get('/gamemini/api/minigame-ranks', {
            params,
        });
    },
    getHistoryMyBet(params: { page: number; size: number; sort: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.post('/api/rh/lichsucuoc', {}, { params });
    },
    getTokenRH(payload: { password: string; rememberMe?: boolean; username: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.post('/api/authenticate', payload);
    },
    getStatistic(): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.get('/gamemini/api/latest100results');
    },
};
export default rongHoApi;
